import "./SeriesAnalysisPage.scss";

import { ChevronStartIcon, Flex, Segment, Text } from "@fluentui/react-northstar";
import { getSurveyTypeDisplay } from "@teams/cards";
import React, { useCallback, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";

import { TeamsLoader } from "../../_shared/components/TeamsLoader";
import { AgileHistoricalTable } from "../../agile/pages/components/AgileHistoricalTable/AgileHistoricalTable";
import { SurveyHistoricalTable } from "../../survey/pages/components/SurveyHistoricalTable";
import { useSeries } from "../actions/useSeries";
import { useUserInfo } from "../actions/useUserInfo";
import { AlertError } from "../components/AlertError";
import { AnalysisHeader } from "../components/AnalysisHeader";
import { NavBarNew } from "../components/NavBar/NavBarNew";
import { NavigationHeader } from "../components/NavigationHeader";
import { PollyIcon } from "../components/PollyIcon";
import { useTeamsContext } from "../state/TeamsContextProvider";

export const SeriesAnalysisPage: React.FC = () => {
  const { seriesId } = useParams<{ seriesId: string }>();
  const history = useHistory();
  const { teamsContext } = useTeamsContext();
  const { error, loadSeries, isSeriesLoading, series } = useSeries();
  const [seriesUpdateInProgress] = useState(false);
  const { user } = useUserInfo();

  const loadSeriesCallback = useCallback(() => {
    loadSeries(teamsContext, seriesId);
  }, [teamsContext, seriesId, loadSeries]);

  useEffect(() => loadSeriesCallback(), [loadSeriesCallback]);

  if (error) {
    return <AlertError error={error} onClick={() => loadSeriesCallback()} />;
  }

  return (
    <Flex column gap="gap.medium" className="series-analysis">
      <NavBarNew />

      <NavigationHeader
        breadcrumbs={[
          {
            icon: <ChevronStartIcon />,
            title: "Back",
            link: "",
            onClick: e => {
              e.preventDefault();
              history.goBack();
            },
          },
        ]}
      />

      <TeamsLoader
        isLoading={isSeriesLoading || seriesUpdateInProgress}
        loadingMessage="Loading history ..."
      >
        {series && (
          <Segment className="series-analysis__container">
            <div className="series-analysis__summary">
              <AnalysisHeader user={user} series={series} onChanged={() => loadSeriesCallback()} />
            </div>
            <div className="series-analysis__history">
              <PollyIcon className="series-analysis__history-icon" icon="clock-icon" />
              <Text
                size="large"
                weight="bold"
                content={`${getSurveyTypeDisplay(series.template.type, {
                  capitalize: true,
                })} History`}
              />
            </div>
            {series.template.type === "agile-standup" && <AgileHistoricalTable series={series} />}
            {series.template.type !== "agile-standup" && <SurveyHistoricalTable series={series} />}
          </Segment>
        )}
      </TeamsLoader>
    </Flex>
  );
};
